/** Shared module-level flag for GTM v2 data layer changes, readable from non-React code (e.g. cart.js). */
let enabled = false;

export function setGtmV2Flag(value: boolean): void {
  enabled = !!value;
}

export function isGtmV2Enabled(): boolean {
  return enabled;
}
